import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

import { I18nService } from '@app/core';

/**
 * Localized currency pipe (i18n)
 */
@Pipe({
  name: 'lcurrency',
  standalone: false
})
export class LcurrencyPipe implements PipeTransform {
  constructor(
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
    private i18nService: I18nService
  ) {}

  transform(value: any, currencyCode?: string, display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean, digitsInfo?: string) {
    // If currencyCode is empty or just whitespace, use DecimalPipe for proper locale formatting
    if (!currencyCode || currencyCode.trim() === '') {
      return this.decimalPipe.transform(value, digitsInfo || '1.2-2', this.i18nService.language);
    }

    return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, this.i18nService.language);
  }
}
